import Controller from "./Controller";
import { ControllerOptions } from "../types/SecurionPayOptions";

export class ControllerProvider {
    private readonly _controllers: { [id: string]: Controller } = {}

    constructor(
      readonly _publicKey: string,
      readonly _options: ControllerOptions,
      readonly _jsId: string) {
    }

    create(): Controller {
        const controller = new Controller(this._publicKey, this._options, { jsId: this._jsId });
        this._controllers[controller._id] = controller
        return controller
    }

    get(id: string): Controller {
        const controller = this._controllers[id];
        if (controller == null) {
            throw new Error("Unknown controller")
        }
        return controller
    }

    has(id: string): boolean {
        if (typeof id !== "string") {
            return null
        }
        return this._controllers[id] != null
    }
}
